import React, { useEffect, useState } from 'react'

const API_Key="AIzaSyA2RgXs9FfTHe2NYOPO3xmq1lsbA1VI-hM";
const ChannelID="UC9hRzq0ZjLQ9HbnBaOHiHWg";

var fetchUrl=`https://www.googleapis.com/youtube/v3/search?key=${API_Key}&channelId=${ChannelID}&part=snippet,id&order=date&maxResult=10`


const YtVideoCard=()=> {
    const [allVideos,setAllVideos]=useState([]);
    useEffect(()=>{
        fetch(fetchUrl).then((response)=>response.json()).then((resJson)=>{
            const result=resJson.items.map(doc=>({
                ...doc,
                Videolink:"https://www.youtube.com/embed/"+doc.id.videoId
            }));
            setAllVideos(result);
        })
    },[])
    console.log("all videos:",allVideos);
    
  return (
    <>
    <div className='m-4'>YtVideoCard</div>
   {allVideos.map((item)=>{
    return(
        <div className='m-2'>
            <iframe width="560" height="315" src={item.Videolink} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    );
   })}
    
    </>
  )
}

export default YtVideoCard